import { config } from 'app/config';

export const CUIT_MAX_LENGTH = 11;
export const ACCOUNT_MAX_LENGTH = 10;
export const MAX_CARD_LENGTH = 16;
export const ENDPOINT = config.apiGateway.URL;